import React, { Component } from "react";
import microsoftSignInDarkBig from "../../images/microsoftSignInDarkBig.png";
import "bootstrap/dist/css/bootstrap.css";
import { Button } from "reactstrap";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import { loginAuthProvider } from "../../LoginAuthProvider";
import { SubscriberAgreement } from "../SubscriberAgreement";
import { SecurityAndPrivacy } from "../SecurityAndPrivacy";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import LogRocket from "logrocket";
import { HelpFooter } from "../HelpFooter";
import { ToastContainer } from 'react-toastify';
import Axios from "axios";
import { getItem } from "../IndexedDBUtils";


export class Home extends Component {
  constructor(props) {
    super(props);
      this.state = {
          DomainResellerId:""
    };
      this.logout = this.logout.bind(this);
      this.getBranding = this.getBranding.bind(this);
  }
  static displayName = Home.name;
    async componentDidMount() {
        const branding = await getItem("Branding");
        const sessionBranding = JSON.parse(branding);
        var DomainResellerId = sessionBranding?.DomainResellerId ?? "";
        if (DomainResellerId === "") {
            this.getBranding();
            
        }
        else {
            this.setState({
                DomainResellerId: DomainResellerId
            });
        }
    }
  logout(event) {
    event.preventDefault();
    loginAuthProvider.logout();
    window.location = "/Logout";
    }
    async getBranding() {
        const config = {
            headers: {
                Authorisation: `Bearer NOT REQUIRED`,
            },
        };
        var response = await Axios.get(API_ROUTE + Routes.GET_BRANDING + "/null/" + window.location.hostname, config);
        try {
            var result = response.data;
            this.setState({
                DomainResellerId: result.domainResellerId
            });
        }
        catch {

        }
    }
  render() {
    ////var accountInfo = loginAuthProvider.getAccountInfo();
    ////var email = "";
    ////var name = "";
    ////if (accountInfo) {
    ////  email = accountInfo.account.userName;
    ////  name = accountInfo.account.name;
    ////}

    let loginButton = (
      <AzureAD provider={loginAuthProvider} forceLogin={false}>
        {({ login, logout, authenticationState, error, accountInfo }) => {
          switch (authenticationState) {
            case AuthenticationState.Authenticated:
              LogRocket.identify(accountInfo.account.userName, {
                name: accountInfo.account.name
              });
              return (
                <React.Fragment>
                  <div>
                          <p style={{ fontWeight: '500', fontFamily: "'Poppins', sans-serif" }}>
                      CloudCover 365 uses your Microsoft account to authenticate
                      you.
                    </p>
                          <p style={{ fontWeight: '500', fontFamily: "'Poppins', sans-serif" }}>
                      You are logged in as {accountInfo.account.name} (
                      {accountInfo.account.userName})
                    </p>
                          <p style={{ fontWeight: '500', fontFamily: "'Poppins', sans-serif" }}>Use these credentials to login to CloudCover 365?</p>
                    <a style={{ cursor: "pointer" }} href={"/Login?autoLogin=true&email=" + accountInfo.account.userName}>
                      <img
                        src={microsoftSignInDarkBig}
                        alt="Sign In"
                        href={"/Login?autoLogin=true&email=" + accountInfo.account.userName}
                        style={{ borderRadius: '0.375rem' }}
                      />
                    </a>
                  </div>
                  <br/>
                  <div>
                    <Button onClick={this.logout} color="dark">Log Out</Button>
                  </div>
                </React.Fragment>
              );
            case AuthenticationState.Unauthenticated:
              return (
                  <div>
                      <p style={{ fontWeight: '500', fontFamily: "'Poppins', sans-serif" }}>
                    CloudCover 365 uses your Microsoft account to authenticate
                    you.
                  </p>
                  <a style={{ cursor: "pointer" }} href="/Login">
                    <img
                        src={microsoftSignInDarkBig}
                        alt="Sign In"
                        href="/Login"
                        style={{ borderRadius:'0.375rem' }}
                    />
                  </a>
                </div>
              );
            case AuthenticationState.InProgress:
                  return <p style={{ fontWeight: '500', fontFamily: "'Poppins', sans-serif" }}>Authenticating...</p>;
            default:
                  return <p style={{ fontWeight: '500', fontFamily: "'Poppins', sans-serif" }}>Error. Please make sure pop-ups are enabled.</p>;
          }
        }}
      </AzureAD>
    );
    const FrontPageTheme = React.lazy(() => import('../ThemeObjects/FrontPage'));
    let chosenTheme = <FrontPageTheme/>
    let themeObject = (
      <React.Suspense fallback={<></>}>
        {chosenTheme}
          </React.Suspense>);

      const currentYear = new Date().getFullYear(); 
    return (
        <div id="ContentPlaceHolder1_UpdatePanel1" className="main-bg" style={{ maxHeight: '93vh', minHeight: '93vh', overflowX: 'hidden', overflowY: 'auto' }}>
            {themeObject}
            <div className="row login" style={{ paddingBottom: '20px', display: 'flex', justifyContent: 'center', height:'90vh' }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="col-xs-12 col-sm-8 col-md-6 col-lg-5 col-xl-4 text-center">
                        <div className="card loginbox" style={{ borderRadius: '18px', backdropFilter: 'blur(45px)', background:'transparent !important' }}>
                            <div className="card-body" style={{ paddingLeft: '17%', paddingRight: '17%' }}>
                                {/*<img src={newloginIcon} alt="Login" style={{ height: '65px' }} />*/}
                                <div className="login-icon" style={{ height: '74px' }} ></div>
                                <h4 className="primary_text">Please log in</h4>
                                <div
                                    id="ContentPlaceHolder1_UsernameBasic"
                                    className="form-group"
                                ></div>
                                {loginButton}
                                <br />
                                <p style={{ fontWeight: '500', fontFamily: "'Poppins', sans-serif" }}>Having trouble logging in? Try our live support below.</p>
                            </div>
                            <div className="card-footer" style={{ marginLeft: '8%', marginRight: '8%', marginBottom:'8%', border: '1px solid lightgray', borderRadius: '10px' }}>
                                <section className="o-panel__section reg-now-content text-center">
                                    <h5 className="secondary-text" id="login-offline-customer">
                                        Do you need to register? Sign up now to protect your data
                                    </h5>
                                    <a id=" " href={
                                        this.state.DomainResellerId && this.state.DomainResellerId !== "default"
                                            ? `/SignUp?resellerId=${this.state.DomainResellerId}`
                                            : '/SignUp'
                                    } className="btn btn-primary" style={{
                                            fontWeight: '700',
                                            pointerEvents: this.state.DomainResellerId === "" ? "none" : "auto",
                                            opacity: this.state.DomainResellerId === "" ? 0.6 : 1
                                        }} aria-disabled={this.state.DomainResellerId === "" ? "true" : "false"}>
                                        Continue
                                    </a>
                                    <hr />
                                </section>
                                <section className="small secondary-text">
                                    <SubscriberAgreement />
                                    |
                                    <SecurityAndPrivacy />
                                    |
                                    <HelpFooter />
                                    <br />© Virtual Data Centre Services Limited {currentYear}
                                </section>
                            </div>

                            <span
                                id="ContentPlaceHolder1_lblLoginResponse"
                                style={{ color: "red" }}
                            ></span>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer limit={4} style={{ fontSize: "small", top: "80px", right: "5px" }} />
      </div>
    );
  }
}
